/* eslint no-console: "off",  */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@cx/ui/Button';
import Alert from '@cx/ui/Alert';
import Grid from '@cx/ui/Grid';
import Col from '@cx/ui/Col';
import Row from '@cx/ui/Row';
import Modal from 'react-bootstrap/lib/Modal';
import './FakeDetailPage.scss';

export default class FakeDetailPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      widgetEditorVisible: '',
      widgetEditorEditting: '',
      widgetEditorMessage: '',
      widgetEditorStartingTab: '0',
      eventInfo: '',
      environment: window.genesisSettings.appEnvironment
    };

    this.addVince = this.addVince.bind(this);
    this.refreshVince = this.refreshVince.bind(this);
    this.openVinceEdit = this.openVinceEdit.bind(this);
    this.openAddVehicle = this.openAddVehicle.bind(this);
    this.onWidgetEditorHide = this.onWidgetEditorHide.bind(this);
    this.onWidgetEditorEnter = this.onWidgetEditorEnter.bind(this);
    this.onWidgetEditorExited = this.onWidgetEditorExited.bind(this);
    this.onWidgetEditorMessageDismiss = this.onWidgetEditorMessageDismiss.bind(this);
    this.onWidgetEditorAttemptClose = this.onWidgetEditorAttemptClose.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id || this.props.match.params.entityId !== prevProps.match.params.entityId) {
      this.loadData();
    }
  }

  redirectToVdp = id => {
    const entityId = this.entityId;
    this.history.push(`/better-fake-vdp/${entityId}/${id}`);
  };

  redirectToEntityVdp = (id, entityId) => {
    this.history.push(`/better-fake-vdp/${entityId}/${id}`);
  };

  loadData = () => {
    try {
      this.addVince();
    } catch (error) {
      console.log(`Caught ${error}, retrying...`);
      setTimeout(this.addVince, 1000);
    }
  };

  get vehicleId() {
    return this.props.match.params.id;
  }

  get entityId() {
    return this.props.match.params.entityId;
  }

  get history() {
    return this.props.history;
  }

  get showModal() {
    return !!this.state.widgetEditorVisible;
  }

  addVince() {
    const self = this,
      vinceInventory = document.getElementById('vince-inventory'),
      vinceVehicle = document.getElementById('vince-vehicle'),
      vincePrice = document.getElementById('vince-price'),
      vinceCostFees = document.getElementById('vince-cost-fees'),
      vinceEquipment = document.getElementById('vince-equipment'),
      vinceCustomFields = document.getElementById('vince-custom-fields'),
      vinceInventoryOwnership = document.getElementById('vince-inventory-ownership');

    vinceInventory.dataset.vehicleId = vinceCostFees.dataset.vehicleId = vincePrice.dataset.vehicleId = vinceVehicle.dataset.vehicleId = self.vehicleId;

    VINCE.init([vinceInventory, vinceVehicle, vinceEquipment, vincePrice, vinceCostFees, vinceCustomFields, vinceInventoryOwnership]);

    VINCE.addEventListener(vinceInventory, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceInventory, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vinceInventoryOwnership, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceInventoryOwnership, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vinceVehicle, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceVehicle, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vinceCostFees, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceCostFees, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vincePrice, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vincePrice, 'vehicleRefresh', {});
      }
    });

    // UNUSED BUT HERE FOR WHEN WE ACTUALLY MAKE API CALLS
    VINCE.addEventListener(vinceEquipment, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceEquipment, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vinceCustomFields, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceCustomFields, 'vehicleRefresh', {});
      }
    });

    // **************************************************************

    VINCE.addEventListener(vinceInventory, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    VINCE.addEventListener(vinceVehicle, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    VINCE.addEventListener(vincePrice, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    VINCE.addEventListener(vinceCostFees, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    // UNUSED BUT HERE FOR WHEN WE ACTUALLY MAKE API CALLS
    VINCE.addEventListener(vinceEquipment, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    VINCE.addEventListener(vinceCustomFields, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    VINCE.addEventListener(vinceInventoryOwnership, 'tokenExpired', function(event) {
      console.log('tokenExpired event recieved');
      self.setState({ widgetEditorMessage: event.message.message });
    });

    // **************************************************************

    VINCE.addEventListener(vinceInventory, 'vehicleOpenInventoryEdit', function(event) {
      console.log(event);
      // Open modal to edit view
      self.openVinceEdit('edit-inventory', 'large', 'Inventory Details');
    });

    VINCE.addEventListener(vinceVehicle, 'vehicleOpenEdit', function(event) {
      console.log(event);
      // Open modal to edit view
      self.openVinceEdit('edit-vehicle', 'large', 'Vehicle Attributes');
    });

    VINCE.addEventListener(vincePrice, 'vehicleOpenPricesEdit', function(event) {
      console.log(event);
      // Open modal to edit view
      self.openVinceEdit('edit-pricing', 'large', 'Edit Price');
    });

    VINCE.addEventListener(vinceCostFees, 'vehicleOpenCostFeesEdit', function(event) {
      console.log(event);
      // Open modal to edit view
      self.openVinceEdit('edit-cost-fees', 'large', 'Costs and Fees', event.message.defaultTab);
    });

    VINCE.addEventListener(vinceEquipment, 'vehicleOpenEquipmentEdit', function(event) {
      console.log(event);
      self.openVinceEdit('edit-equipment', 'large', 'Vehicle Equipment');
    });

    VINCE.addEventListener(vinceEquipment, 'vehicleOpenEdit', function(event) {
      console.log(event);
      self.openVinceEdit('edit-vehicle', 'large', 'Inventory Details');
    });

    VINCE.addEventListener(vinceCustomFields, 'vehicleOpenCustomFieldsEdit', function(event) {
      console.log(event);
      self.openVinceEdit('edit-custom-fields', 'large', 'Custom Fields');
    });
  }

  refreshVince() {
    const vinceInventory = document.getElementById('vince-inventory'),
      vinceVehicle = document.getElementById('vince-vehicle'),
      vincePrice = document.getElementById('vince-price'),
      vinceCostFees = document.getElementById('vince-cost-fees'),
      vinceEquipment = document.getElementById('vince-equipment'),
      vinceCustomFields = document.getElementById('vince-custom-fields'),
      vinceInventoryOwnership = document.getElementById('vince-inventory-ownership');

    VINCE.sendEvent(vincePrice, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceCostFees, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceInventory, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceVehicle, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceEquipment, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceCustomFields, 'vehicleRefresh', {});
    VINCE.sendEvent(vinceInventoryOwnership, 'vehicleRefresh', {});
  }

  openVinceEdit(widget, size, editting, tab) {
    console.log('EDITING!!!');
    console.log(widget);
    this.setState({
      widgetEditorVisible: widget,
      widgetEditorSize: size || '',
      widgetEditorEditting: editting,
      widgetEditorStartingTab: tab
    });
    console.log(this.state);
  }

  openAddVehicle() {
    console.log('EDITING!!!');
    console.log('add-vehicle');
    this.setState({
      widgetEditorVisible: 'add-vehicle',
      widgetEditorSize: 'large',
      widgetEditorEditting: 'Add Vehicle'
    });
    console.log(this.state);
  }

  onWidgetEditorEnter() {
    const self = this,
      vinceEditor = document.getElementById('vince-editor');

    vinceEditor.classList.add('vince-embed');
    vinceEditor.dataset.id = self.vehicleId;
    vinceEditor.dataset.entityId = self.entityId;
    vinceEditor.dataset.path = self.state.widgetEditorVisible;
    vinceEditor.dataset.accessToken = self.props.accessToken;
    vinceEditor.dataset.defaultTab = self.state.widgetEditorStartingTab;

    VINCE.init([vinceEditor]);

    VINCE.addEventListener(vinceEditor, 'vehicleTransfer', function(event) {
      console.log(event);

      self.setState(
        {
          widgetEditorVisible: undefined
        },
        () => {
          self.redirectToEntityVdp(event.message.transferResult.inventoryId, event.message.transferResult.entityId);
        }
      );
    });

    VINCE.addEventListener(vinceEditor, 'vehicleRecovered', function(event) {
      console.log(event);

      self.setState(
        {
          widgetEditorVisible: undefined
        },
        () => {
          self.redirectToVdp(event.message.id);
        }
      );
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCreated', function(event) {
      console.log(event);

      if (event.message.close) {
        self.setState(
          {
            widgetEditorVisible: undefined
          },
          () => {
            self.redirectToVdp(event.message.id);
          }
        );
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCreateExist', function(event) {
      console.log(event);

      if (event.message.close) {
        self.setState(
          {
            widgetEditorVisible: undefined
          },
          () => {
            self.redirectToVdp(event.message.id);
          }
        );
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCreateFailed', function(event) {
      console.log(event);
      self.setState({
        widgetEditorVisible: undefined
      });
    });

    VINCE.addEventListener(vinceEditor, 'vehicleSave', function(event) {
      console.log(event);

      // Go back to readonly view, close modal
      self.setState({
        widgetEditorVisible: '',
        widgetEditorSize: '',
        widgetEditorMessage: 'Vehicle updated!',
        widgetEditorEditting: ''
      });

      // Redirect to new inventory page, if inventory was transferred.
      const transferResult = event.message.transferResult;
      if (transferResult) {
        const destEntityId = transferResult.entityId;
        const newInventoryId = transferResult.inventoryId;
        self.history.push(`/better-fake-vdp/${destEntityId}/${newInventoryId}`);
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleCancelEdit', function(event) {
      console.log(event);

      if (event.message.close || !event.message.dirty) {
        self.setState({
          widgetEditorVisible: '',
          widgetEditorSize: '',
          widgetEditorEditting: ''
        });

        console.log(`The following fields were dirty: ${event.message.dirtyFieldPaths}`);
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleNotFound', function(event) {
      console.log(event);
      // Force refresh to fix our too-slow eventual consistency for now
      if (event.message.params && !event.message.params.consistentRead) {
        VINCE.sendEvent(vinceEditor, 'vehicleRefresh', {});
      }
    });

    VINCE.addEventListener(vinceEditor, 'vehicleFieldChange', function(event) {
      console.log(event);

      self.setState({ eventInfo: event.message });
    });
  }

  // refresh will not do anything as there was no refresh event listener in the components
  onWidgetEditorExited() {
    this.refreshVince();
  }

  onWidgetEditorHide() {
    this.setState({
      widgetEditorVisible: '',
      widgetEditorSize: '',
      eventInfo: ''
    });
  }

  onWidgetEditorMessageDismiss() {
    this.setState({ widgetEditorMessage: '' });
  }

  onWidgetEditorAttemptClose() {
    const vinceEditor = document.getElementById('vince-editor');
    VINCE.sendEvent(vinceEditor, 'closeEditor', {});
    vinceEditor.scrollIntoView();
  }

  render() {
    const self = this;

    const backToVLP = `/vehicles/${this.entityId}`;

    return (
      <div className="vdp">
        <header className="vince-page-header">
          {!!self.state.widgetEditorMessage &&
            !self.showModal && (
              <Alert htmlId="infoAlert" type="info" onDismiss={self.onWidgetEditorMessageDismiss}>
                {self.state.widgetEditorMessage}
              </Alert>
            )}

          <h1>Vehicle Detail Page</h1>
          <div className="vince-page-header-actions">
            <Link to={backToVLP}>Back to VLP &nbsp; | &nbsp;&nbsp;&nbsp; </Link>
            <Button id="vlp-open-add-vehicle" htmlId="vlp-open-add-vehicle" onClick={self.openAddVehicle}>
              Add New Vehicle
            </Button>
          </div>
        </header>

        <Grid fluid className="template-page-wrapper page-wrapper__content-only">
          <Row>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-vehicle" className="vince-embed" data-auto-resize="true" data-path="read-only-vehicle" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-inventory" className="vince-embed" data-auto-resize="true" data-path="read-only-inventory" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-equipment" className="vince-embed" data-auto-resize="true" data-path="read-only-equipment" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-price" className="vince-embed" data-auto-resize="true" data-path="read-only-pricing" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-cost-fees" className="vince-embed" data-auto-resize="true" data-path="read-only-cost-fees" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-custom-fields" className="vince-embed" data-auto-resize="true" data-path="read-only-custom-fields" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={6} lg={4}>
              <div className="template-content-wrapper content-wrapper__content-only">
                <div id="vince-inventory-ownership" className="vince-embed" data-auto-resize="true" data-path="read-only-inventory-ownership" data-access-token={self.props.accessToken} data-id={self.vehicleId} data-entity-id={self.entityId} />
              </div>
            </Col>
          </Row>
          <Row className="invisible">
            <Col>
              <div id="eventInformation">{JSON.stringify(self.state.eventInfo)}</div>
            </Col>
          </Row>
        </Grid>
        <Modal show={self.showModal} container={self} onHide={self.onWidgetEditorAttemptClose} onEnter={self.onWidgetEditorEnter} onExited={self.onWidgetEditorExited} bsSize={self.state.widgetEditorSize}>
          <div id="vince-editor" data-auto-resize="true" data-mode="edit" />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/FakeDetailPage.js